import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { RootState, useDispatch, useSelector } from 'src/store';
import { editBtnType } from 'src/store/modules/buttons';

const useStyles = makeStyles(() => ({
  buttonTypeWrapper: {
    display: 'flex',
    flexDirection: 'column',

    width: '100%',
    padding: '16px 16px 16px 16px',
    gap: '24px',
    backgroundColor: '#F5F5F5'
  },
  toggleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '45px',
    padding: '8px',
    border: '1px solid #D9D9D9'
  },
  toggleButton: {
    border: 'none',
    borderRadius: '0',
    width: '130px',
    fontFamily: 'Archivo',

    '&.Mui-selected': {
      color: '#000000'
    }
  }
}));
export default function EditButtonType() {
  let btnType = useSelector((state: RootState) => state.buttons.btnType);

  const classes = useStyles();
  const dispatch = useDispatch();
  const [buttonCount, setButtonCount] = useState(btnType);

  useEffect(() => {
    setButtonCount(btnType);
  }, [btnType]);

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    count: string | null
  ) => {
    if (count !== null) {
      setButtonCount(count);
      dispatch(editBtnType(count));
    }
  };

  return (
    <div className={classes.buttonTypeWrapper}>
      <span
        style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem'
        }}
      >
        BUTTON TYPE
      </span>
      <ToggleButtonGroup
        className={classes.toggleContainer}
        value={buttonCount}
        exclusive
        onChange={handleAlignment}
      >
        <ToggleButton className={classes.toggleButton} value="single">
          SINGLE
        </ToggleButton>
        <ToggleButton className={classes.toggleButton} value="double">
          DOUBLE
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}
